<template>
    <div>
        <h5 v-lang.contacto></h5>
        <address>
            <ul class="address_details">
                <li><i class="glyphicon glyphicon-map-marker"></i> {{ address }}</li>
                <li><i class="glyphicon glyphicon-phone-alt"></i> {{ phone }} </li>
                <li v-if="fax!=null"><i class="fa fa-fax"></i> {{ fax }}</li>
                <li><i class="fa fa-envelope"></i><a v-bind:href="adddressMail">{{ email }}</a></li>
            </ul>
        </address>
    </div>
</template>

<script>
    import config from '../../config/app';
    export default {
        data : function(){
            return {
                address  : null,
                phone : null,
                email : null,
                webpage : null,
                fax : null
            }
        },
        created : function(){
            var self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                self.$language = self.$store.state.language;
            });
            this.$store.watch( (state)=> {return this.$store.getters.config; }, (val) => {
                self.phone = val.contact.phone;
                self.email = val.contact.email;
                self.address  = val.contact.address;
                self.webpage  = val.contact.webpage;
                self.fax = val.contact.fax;
            });
        },
        mounted : function(){
            let self = this;
            let config = this.$store.getters.config;
            if( !_.isNull(config) )
            {
                console.log(config);
                self.phone = config.contact.phone;
                self.email = config.contact.email;
                self.address  = config.contact.address;
                self.webpage  = config.contact.webpage;
                self.fax = config.contact.fax;
            }
        },
        beforeDestroy : function(){
            this.unsubscribe();
        },
        computed : {
            adddressMail : function(){
                return `mailto:${this.email}`;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Contact.vue?f546c1a6